module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Auto-start</span></div>\r\n<div class=\"nav-position prop-detail\" >\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <div><input type=\"radio\" name=\"autoStart\" value=\"none\"/> None</div>\r\n            <div><input type=\"radio\" name=\"autoStart\" value=\"start\" /> Start</div>\r\n            <div><input type=\"radio\" name=\"autoStart\" value=\"continue\" /> Continue</div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}